<crm-form-loading-indicator [loadingStatus]="loadingStatus">
  <form class="crm-model-driven-form crm-panel-form" form-content [formGroup]="formGroup">
    <!-- groups are ignored in panel model -->
    <ng-container *ngFor="let renderableFieldGroup of renderableFieldGroups">
      <ng-container *ngFor="let renderableField of renderableFieldGroup.fields">
        <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
      </ng-container>
    </ng-container>
    <mat-divider class="divider" *ngIf="readonlyRenderableFieldGroups?.length > 0"></mat-divider>
    <ng-container *ngFor="let readOnlyrenderableFieldGroup of readonlyRenderableFieldGroups">
      <ng-container *ngFor="let readOnlyrenderableField of readOnlyrenderableFieldGroup.fields">
        <crm-renderer-selector [handler]="readOnlyrenderableField"></crm-renderer-selector>
      </ng-container>
    </ng-container>
    <div *ngIf="!readOnly && !inlineEdit" class="crm-panel-button-container">
      <crm-form-button-group
        [submitButtonText]="submitButtonText | translate"
        [cancelButtonText]="cancelButtonText | translate"
        [savingStatus]="savingStatus"
        (clickedOnSubmit)="onSubmit()"
        (clickedOnCancel)="onCancel()"
      ></crm-form-button-group>
    </div>
  </form>
</crm-form-loading-indicator>
